export const shippingSources = {
  1: "Проимпорт",
  2: "Кабинет клиента",
};
